webpackJsonp([49978712923209],{

/***/ 321:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week/"},"frontmatter":{"title":"Just in: small batch of Jamaican Blue Mountain in store next week"}}}]}},"pathContext":{"tag":"jamaica"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-jamaica-6b689e1efcdb6243a1f1.js